import { useContext, useState, useEffect, useRef } from 'react';
import { SelectStoreModal } from './SelectStoreModal';
import { MobileFooter } from './MobileFooter';
import { UserContext } from '../../../../shared/useUser';
import { useActiveOrder } from '../../../../../contexts/ActiveOrderContext';
import { useNavigate } from 'react-router-dom';

export const Footer = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const { forceLogout, selectedStore } = useContext(UserContext);
  const { clearActiveOrder } = useActiveOrder();
  const navigate = useNavigate();
  const previousStoreRef = useRef(selectedStore);
  const [storeChangePending, setStoreChangePending] = useState(false);

  useEffect(() => {
    if (storeChangePending && selectedStore && selectedStore !== previousStoreRef.current) {
      previousStoreRef.current = selectedStore;
      setStoreChangePending(false);
      navigate('/', { replace: true });
    }
  }, [selectedStore, storeChangePending, navigate]);

  const onLogout = () => {
    clearActiveOrder();
    forceLogout();
  };

  const onStoreSelected = () => {
    clearActiveOrder();
    setModalOpen(false);
    setStoreChangePending(true);
  };

  return <>
    <MobileFooter onSwitchStore={() => setModalOpen(true)}
      onLogOut={onLogout} />
    <SelectStoreModal
      open={modalOpen}
      onConfirm={onStoreSelected}
      onClose={() => setModalOpen(false)} />
  </>;
};
